function buocChuVuonChiTiet() {
  return [
    {
      target: "body",
      placement: "center",
      title: "Bước 1 · Chi tiết chủ vườn",
      content: "Xem hồ sơ, lịch sử giao dịch và mã QR của chủ vườn.",
    },
    {
      target: "#tour-chu-vuon-chi-tiet-lich-su",
      title: "Bước 2 · Lịch sử giao dịch",
      content:
        "Toàn bộ phiếu thu mua đã ghi cho chủ vườn này — mỗi dòng là 1 lượt thu mua (PO), tổng kg và tổng tiền cộng dồn hiện ở cuối bảng.",
      placement: "top",
    },
    {
      target: "#tour-chu-vuon-chi-tiet-qr",
      title: "Bước 3 · Mã QR chủ vườn",
      content:
        'In hoặc tải mã này để dán tại vườn — nhân viên quét để mở đúng hồ sơ chủ vườn khi thu mua lần sau, không cần gõ CCCD. Nếu hiện "chủ vườn này chưa có mã", cần liên hệ quản trị viên.',
      placement: "top",
    },
  ];
}

export default buocChuVuonChiTiet;
